(function () {
  'use strict';

  /* --------------------------------------------------------------------------------
  PC/SP限定改行
  管理画面のrichtext設定にはbrへのclass付与が許可されていないため、
  本文中に目印として入力された [PC_BR] / [SP_BR] という文字列を、
  表示時にそれぞれ <br class="nom-br-pc"> / <br class="nom-br-sp"> へ変換する
  （PC/SPどちらか一方だけで改行させたい場合、nom-theme.css で他方の表示を隠す）
  -------------------------------------------------------------------------------- */
  const BR_MARKERS = [
    { marker: '[PC_BR]', className: 'nom-br-pc' },
    { marker: '[SP_BR]', className: 'nom-br-sp' },
  ];

  const containsAnyMarker = (text) => BR_MARKERS.some(({ marker }) => text.includes(marker));

  const replaceBrMarkers = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => containsAnyMarker(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT,
    });

    const targetNodes = [];
    let currentNode = walker.nextNode();
    while (currentNode) {
      targetNodes.push(currentNode);
      currentNode = walker.nextNode();
    }

    const splitPattern = new RegExp(`(${BR_MARKERS.map(({ marker }) => marker.replace(/[[\]]/g, '\\$&')).join('|')})`);

    targetNodes.forEach((node) => {
      const parts = node.nodeValue.split(splitPattern);
      const fragment = document.createDocumentFragment();

      parts.forEach((part) => {
        const matchedMarker = BR_MARKERS.find(({ marker }) => marker === part);
        if (matchedMarker) {
          const br = document.createElement('br');
          br.className = matchedMarker.className;
          fragment.appendChild(br);
        } else if (part !== '') {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      node.parentNode.replaceChild(fragment, node);
    });
  };

  const init = () => {
    replaceBrMarkers();
  };

  document.addEventListener('DOMContentLoaded', init);
})();
